import permission from "./permission";
var install = function install(Vue) {
  Vue.directive('has', permission);
};
if (window.Vue) {
  window['has'] = permission;
  Vue.use(install); // eslint-disable-line
}
permission.install = install;
export default permission;